export default __webpack_public_path__ + "static/media/kitchen5-afterC-2048w.381ff695.webp";